module.exports = __webpack_public_path__ + "img/portfolio1m-m@1.c4ac3b79.webp";